module.exports = __webpack_public_path__ + "img/logo.ac289917.png";